import React from 'react';
import InnerPageBanner from '../../../components/InnerPageBanner';
import { Box, Container, Typography, Grid } from '@mui/material';
import { handleImageClick } from '../../../utils/imageUtils';

// Import all 29 cobble stone lying images
// ... (imports remain the same)
import lying1 from "../../../assets/images/lying-and-path1.jpeg";
import lying2 from "../../../assets/images/lying-and-path2.jpeg";
import lying3 from "../../../assets/images/lying-and-path3.jpeg";
import lying4 from "../../../assets/images/lying-and-path4.jpeg";
import lying5 from "../../../assets/images/lying-and-path5.jpeg";
import lying6 from "../../../assets/images/lying-and-path6.jpeg";
import lying7 from "../../../assets/images/lying-and-path7.jpeg";
import lying8 from "../../../assets/images/lying-and-path8.jpeg";
import lying9 from "../../../assets/images/lying-and-path9.jpeg";
import lying10 from "../../../assets/images/lying-and-path10.jpeg";
import lying11 from "../../../assets/images/lying-and-path11.jpeg";
import lying12 from "../../../assets/images/lying-and-path12.jpeg";
import lying13 from "../../../assets/images/lying-and-path13.jpeg";
import lying14 from "../../../assets/images/lying-and-path14.jpeg";
import lying15 from "../../../assets/images/lying-and-path15.jpeg";
import lying16 from "../../../assets/images/lying-and-path16.jpeg";
import lying17 from "../../../assets/images/lying-and-path17.jpeg";
import lying18 from "../../../assets/images/lying-and-path18.jpeg";
import lying19 from "../../../assets/images/lying-and-path19.jpeg";
import lying20 from "../../../assets/images/lying-and-path20.jpeg";
import lying21 from "../../../assets/images/lying-and-path21.jpeg";
import lying22 from "../../../assets/images/lying-and-path22.jpeg";
import lying23 from "../../../assets/images/lying-and-path23.jpeg";
import lying24 from "../../../assets/images/lying-and-path24.jpeg";
import lying25 from "../../../assets/images/lying-and-path25.jpeg";
import lying26 from "../../../assets/images/lying-and-path26.jpeg";
import lying27 from "../../../assets/images/lying-and-path27.jpeg";
import lying28 from "../../../assets/images/lying-and-path28.jpeg";
import lying29 from "../../../assets/images/lying-and-path29.jpeg";

// Create array of all images
const lyingImages = [
    lying1, lying2, lying3, lying4, lying5, lying6, lying7, lying8, lying9, lying10,
    lying11, lying12, lying13, lying14, lying15, lying16, lying17, lying18, lying19, lying20,
    lying21, lying22, lying23, lying24, lying25, lying26, lying27, lying28, lying29
];

const CobbleStoneLying = () => {
    return (
        <Box>
            <InnerPageBanner title="Cobble Stone Lying" image={lying1} />
            <Container sx={{ py: 5 }}>

                <Box sx={{
                    backgroundColor: "#f5f5f5",
                    py: { xs: 4, md: 6 },
                    px: { xs: 2, md: 4 },
                    borderRadius: 2
                }}>
                    {/* ===== Top Hero Section ===== */}
                    <Box
                        sx={{
                            backgroundColor: "#eaeaea",
                            p: { xs: 3, sm: 5, md: 8 },
                            mb: { xs: 5, md: 8 },
                            borderRadius: 2
                        }}
                    >
                        <Typography
                            variant="body2"
                            sx={{ color: "#777", mb: 2, fontSize: { xs: 12, md: 14 } }}
                        >
                            No Doubt We Are Trusted
                        </Typography>

                        <Typography
                            sx={{
                                fontWeight: 700,
                                fontSize: { xs: 24, sm: 28, md: 36 }
                            }}
                        >
                            Cobble Stone Lying
                        </Typography>

                        <Box
                            sx={{
                                width: 50,
                                height: 3,
                                backgroundColor: "#1abc9c",
                                my: 2
                            }}
                        />

                        <Box sx={{ mt: 3 }}>
                            <Typography sx={{ fontSize: { xs: 13, md: 14 } }}>
                                <strong>Description</strong><br />
                                Expert laying and path solutions for cobblestones.
                            </Typography>
                        </Box>
                    </Box>

                    {/* ===== Image Gallery Section ===== */}
                    <Typography
                        sx={{
                            fontWeight: 700,
                            mb: 3,
                            fontSize: { xs: 20, md: 24 }
                        }}
                    >
                        Cobble Stone Lying Models
                    </Typography>

                    <Box sx={{ width: 40, height: 3, backgroundColor: "#1abc9c", mb: 4 }} />

                    <Grid container spacing={4}>
                        {/* All 29 Images in Grid */}
                        {lyingImages.map((image, index) => (
                            <Grid size={{ xs: 12, sm: 6, md: 6 }} key={index}>
                                <Box
                                    component="img"
                                    src={image}
                                    alt={`Cobble Stone Lying ${index + 1}`}
                                    onClick={() => handleImageClick(image)}
                                    sx={{
                                        width: "100%",
                                        height: { xs: 200, sm: 220, md: 250 },
                                        objectFit: "cover",
                                        border: "1px solid #ccc",
                                        borderRadius: 2,
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                        cursor: 'pointer',
                                        transition: 'transform 0.3s',
                                        '&:hover': {
                                            transform: 'scale(1.02)',
                                            boxShadow: '0 8px 20px rgba(0,0,0,0.15)'
                                        }
                                    }}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Container>
        </Box>
    );
};

export default CobbleStoneLying;